export default __webpack_public_path__ + "images/WO.24537f5.png";